import { Outlet } from 'react-router';

export function AuthLayout() {
    return (
        <div className="flex min-h-screen items-center justify-center bg-muted">
            <div className="w-full max-w-md">
                <Outlet />
            </div>
        </div>
    );
}

export default AuthLayout;
